import { useApiAccountsUsersList } from "@/api/lctApIComponents";
import { DataTable } from "@/components/DataTable";
import { PageHeader } from "@/components/PageHeader";
import { useAppSelector } from "@/hooks/reduxHooks";
import { TABLE_IDS } from "@/utils/constants";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";

interface IProps {}

export const UserTable: React.FC<IProps> = () => {
  const token = useAppSelector((state) => state.user.authKey);
  const { data, isLoading } = useApiAccountsUsersList({ headers: { Authorization: `Token ${token}` } });

  type Data = {
    name: string;
    userName: string;
    email: string | undefined;
    isStaff: boolean | undefined;
    staffStatusText: string;
  };

  const tableData: Data[] = useMemo(() => {
    return (
      data?.results.map((user) => ({
        name: user.first_name && user.last_name ? `${user.first_name} ${user.last_name}` : "-",
        userName: user.username || "-",
        email: user?.email || "-",
        isStaff: user.is_staff || false,
        staffStatusText: user.is_staff ? "Staff" : "User",
      })) ?? []
    );
  }, [data?.results]);

  const { accessor } = createColumnHelper<Data>();

  const columns = useMemo(() => {
    return [
      accessor("name", {
        id: "name",
        header: "Name",
        cell: (info) => info.getValue(),
      }),
      accessor("userName", {
        id: "userName",
        header: "User Name",
        cell: (info) => info.getValue(),
      }),
      accessor("email", {
        id: "email",
        header: "Email",
        cell: (info) => info.getValue(),
        meta: {
          isEmail: true,
          canCopy: true,
        },
      }),
      accessor("staffStatusText", {
        id: "staffStatusText",
        header: "Staff Status",
        cell: (info) => info.getValue(),
      }),
    ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="mt-4">
      <PageHeader title="Users" />
      <div className="mt-4">
        <DataTable tableId={TABLE_IDS.USERS} columns={columns} data={tableData} loading={isLoading} />
      </div>
    </section>
  );
};
